const Env = {
  API_EMAIL: process.env.REACT_APP_API_EMAIL,
  API_URL: process.env.REACT_APP_API_URL,
  CAPTCHA_KEY: process.env.REACT_APP_CAPTCHA_KEY
    ? process.env.REACT_APP_CAPTCHA_KEY
    : "",
  CHATBOT_URL: process.env.REACT_APP_CHATBOT_API_URL,
};

export default Env;
